import React, { useState, useEffect } from 'react';
import LogService from '../services/logService';
import { Log } from '../types';
// CSS đã được hợp nhất vào App.css
import AuthService from '../services/authService';

const LogList: React.FC = () => {
  const [logs, setLogs] = useState<Log[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  // Bộ lọc
  const [resourceType, setResourceType] = useState<string>('');
  const [action, setAction] = useState<string>('');
  const [startDate, setStartDate] = useState<string>('');
  const [endDate, setEndDate] = useState<string>('');
  const [isFilterVisible, setIsFilterVisible] = useState<boolean>(false);

  useEffect(() => {
    loadLogs();
  }, []);

  // Tự động tìm kiếm khi thay đổi các bộ lọc
  useEffect(() => {
    if (resourceType || action || startDate || endDate) {
      searchLogs();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resourceType, action, startDate, endDate]);

  const loadLogs = async () => {
    try {
      setLoading(true);
      const response = await LogService.getAll();
      setLogs(response.data);
      setError(null);
    } catch (err) {
      setError('Không thể tải danh sách hoạt động. Vui lòng thử lại sau.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const searchLogs = async () => {
    const params: any = {};

    if (resourceType) params.resourceType = resourceType;
    if (action) params.action = action;
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;

    // Nếu không có bộ lọc nào được chọn, tải tất cả logs
    if (Object.keys(params).length === 0) {
      loadLogs();
      return;
    }

    try {
      setLoading(true);
      const response = await LogService.search(params);
      setLogs(response.data);
      setError(null);
    } catch (err) {
      setError('Không thể tìm kiếm hoạt động. Vui lòng thử lại sau.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const toggleFilterVisibility = () => {
    setIsFilterVisible(!isFilterVisible);
  };

  const resetFilters = () => {
    setResourceType('');
    setAction('');
    setStartDate('');
    setEndDate('');
  };






  const getRowClass = (action: string, details: string) => {
    // Đổi màu đỏ cho trạng thái đơn hàng từ Đang xử lý sang Đã hủy
    if (details && details.includes('Cập nhật trạng thái đơn hàng') &&
      details.includes('từ Đang xử lý') &&
      details.includes('sang Đã hủy')) {
      return 'table-danger';
    }

    // Màu mặc định dựa vào loại hành động
    switch (action) {
      case 'created':
        return 'table-success';
      case 'updated':
        return 'table-primary';
      case 'deleted':
        return 'table-danger';
      default:
        return '';
    }
  };

  const formatDetails = (details: string, resourceType: string, resourceId: any) => {
    if (resourceType === 'order') {
      if (details.includes('Cập nhật trạng thái đơn hàng')) {
        return `Cập nhật trạng thái đơn hàng #${resourceId}`;
      }

      if (details.includes('đã được tạo')) {
        return `Tạo đơn hàng #${resourceId}`;
      }

      if (details.includes('đã được cập nhật')) {
        return `Cập nhật đơn hàng #${resourceId}`;
      }

      if (details.includes('đã bị xóa')) {
        return `Xóa đơn hàng #${resourceId}#`;
      }
    }

    // Đối với các loại tài nguyên khác
    if (resourceType === 'customer') {
      return `${details.split('"')[0].trim()} "${resourceId}"`;
    }

    if (resourceType === 'staff') {
      return `${details.split('"')[0].trim()} "${resourceId}"`;
    }

    return details;
  };

  const isAdmin = AuthService.isAdmin();

  return (
    <div className="content">
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-header">
              <div className="d-flex justify-content-between align-items-center" style={{paddingLeft: '12rem'}}>
               
                <button
                  className="btn btn-info"
                  onClick={toggleFilterVisibility}
                >
                  <i className="fa-solid fa-magnifying-glass"></i> Tìm kiếm nâng cao
                </button>
              </div>

            </div>
            <div className="card-body">
              {isFilterVisible && (
                <div className="card mb-4 mt-3">
                  
                  <div className="card-body">
                    <div className="row">
                      <div className="col-12 col-md-3">
                        <div className="form-group">
                          <label htmlFor="resourceType">Loại tài nguyên</label>
                          <select
                            className="form-control"
                            id="resourceType"
                            value={resourceType}
                            onChange={(e) => setResourceType(e.target.value)}
                          >
                            <option value="">Tất cả</option>
                            <option value="order">Đơn hàng</option>
                            <option value="customer">Khách hàng</option>
                            <option value="staff">Nhân viên</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-12 col-md-3">
                        <div className="form-group">
                          <label htmlFor="action">Hành động</label>
                          <select
                            className="form-control"
                            id="action"
                            value={action}
                            onChange={(e) => setAction(e.target.value)}
                          >
                            <option value="">Tất cả</option>
                            <option value="created">Tạo mới</option>
                            <option value="updated">Cập nhật</option>
                            <option value="deleted">Xóa</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-12 col-md-3">
                        <div className="form-group">
                          <label htmlFor="startDate">Từ ngày</label>
                          <input
                            type="date"
                            className="form-control"
                            id="startDate"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-3">
                        <div className="form-group">
                          <label htmlFor="endDate">Đến ngày</label>
                          <input
                            type="date"
                            className="form-control"
                            id="endDate"
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="mt-3 d-flex justify-content-end">
                      <button
                        className="btn btn-secondary"
                        onClick={resetFilters}
                      >
                        <i className="fa-solid fa-arrows-rotate"></i> Đặt lại
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {error && <div className="alert alert-danger">{error}</div>}

              {loading ? (
                <div className="center-screen">
                  <div className="spinner-border text-primary" role="status" aria-label="loading"></div>
                </div>
              ) : (
                <div className="table-responsive">
                  <table className="table">
                    <thead className="text-primary">
                      <tr>
                        <th className="time-column">Thời gian</th>
                        <th>Chi tiết</th>
                        <th>Thực hiện</th>
                      </tr>
                    </thead>
                    <tbody>
                      {logs.length > 0 ? (
                        logs.map((log) => (
                          <tr key={log.id} className={getRowClass(log.action, log.details)}>
                            <td className="time-column">{log.createdAt ? new Date(log.createdAt).toLocaleString('vi-VN') : 'N/A'}</td>
                            <td>{formatDetails(log.details, log.resourceType, log.resourceId)}</td>
                            <td>{log.performedBy?.fullName || `ID: ${log.performedById}`}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={3} className="text-center">
                            Không tìm thấy hoạt động nào
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogList; 